import { z } from 'zod'

// Zod probes `new Function` to decide whether to compile parsers. It falls back without eval, but under
// the strict CSP every probe is reported as a violation, so skip the probe.
z.config({ jitless: true })
